module.exports = __webpack_public_path__ + "static/media/Interactive Data Visualization with Altair.a66a32c4.png";